// extracted by mini-css-extract-plugin
export default {"root":"styles_root__dWJze","title":"styles_title__ZFuVk","dataContainer":"styles_dataContainer__OmQxE","tableContainer":"styles_tableContainer__0eH3t"};